<template>
    <div
        ref="currectAnswersModal"
        class="correct-answers-modal"
        :class="{
            'animated bounceIn': isAnimate,
            'centered-popup': isCentered,
            'master-centered-modal': master
        }"
        :style="`top: ${popupTop}px;left: calc(${popupLeft}px + ${leftGap}px);will-change: transform;`"
    >
        <div class="close fixed text-right">
            <i @click="closeModal" class="fas fa-times text-3xl cursor-pointer shadow-text-none"></i>
        </div>
        <div class="text-center text-color">
            <div class="title uppercase font-size-18 font-opensans font-bold" v-if="showTitle">
                {{ $t('correct_modal_show_correct') }}
            </div>
            <div
                class="answer-container"
                v-if="!isHotspot"
                :class="{
                    'flex items-center justify-center': correctAnswer.length === 1
                }"
            >
                <div
                    :class="{
                        'max-w-md mx-auto pb-6': true,
                        'pt-3': showTitle,
                        'pt-6': !showTitle
                    }"
                >
                    <div v-if="correctAnswer" class="font-size-18">
                        <span
                            class="mb-3 font-size-16 flex items-center font-bold justify-center shadow-text-none"
                            v-if="answersRequired"
                            >{{ $t('correct_modal_answer_required') }}: {{ answersRequired }}</span
                        >
                        <div
                            v-if="!isHotspot"
                            :class="{
                                'flex justify-center flex-col py-3': true,
                                'sorting-list': isSorting,
                                'answer-required-one': answersRequired && answersRequired === 'one',
                                'answer-required-multiple': answersRequired && answersRequired === 'multiple'
                            }"
                        >
                            <div
                                :class="{
                                    'list-item': true
                                }"
                                :key="index"
                                v-for="(item, index) in correctAnswer"
                            >
                                <div
                                    :class="{
                                        'flex justify-center items-center list-item-inner': true,
                                        'justify-center': !isSorting,
                                        'py-2 mb-1': correctAnswer.length > 1
                                    }"
                                >
                                    <div
                                        v-if="
                                            (item.image && item.image.length > 0) ||
                                            (isSorting &&
                                                correctAnswer.findIndex(e => e.image.length > 0) > -1 &&
                                                item.image) ||
                                            isPuzzle
                                        "
                                        :style="{
                                            'background-image': 'url(' + (isPuzzle ? question.image : item.image) + ')'
                                        }"
                                        class="border-3 bg-cover bg-center bg-norepeat border-style"
                                        :class="{
                                            'mb-4': !item.image && !isSorting && item.title,
                                            'w-12 h-12 mr-3': isSorting,
                                            'w-32 h-32': !isSorting
                                        }"
                                    ></div>

                                    <div
                                        v-if="
                                            (!item.image && !isSorting && item.title && !isPuzzle) ||
                                            (isSorting && item.title)
                                        "
                                        :class="{
                                            'font-size-20 lg:font-size-24':
                                                (!item.image && !isSorting) ||
                                                (isSorting && correctAnswer.findIndex(e => e.image.length > 0) < 0),
                                            'text-center': !isSorting,
                                            'text-left': isSorting
                                        }"
                                    >
                                        <span class="font-bold shadow-text-none">
                                            {{ isSorting ? item.title : `${item.title}` }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span
                class="mb-3 pt-3 font-size-16 flex items-center font-bold justify-center shadow-text-none"
                v-if="isHotspot && answersRequired"
                >{{ $t('correct_modal_answer_required') }}: {{ answersRequired }}</span
            >
            <div
                v-if="isHotspot"
                :class="{ 'hotspot-padding': isHotspot }"
                :style="answersRequired ? { padding: '1rem' } : { padding: '3rem 1rem 1rem 1rem' }"
            >
                <HotspotAnswer
                    :question="question"
                    :show-correct="true"
                    :show-all-choices="false"
                    :is-interact="false"
                />
            </div>
            <div v-if="!isPaidUser && master" class="m-4 text-sm">
                <div class="upgrade-box">
                    <i class="fas fa-exclamation-circle shadow-text-none"></i>
                    <span class="shadow-text-none">
                        {{ $t('playlive_master_result_warning_show_correct_to_user') }}
                        <a class="text-color" target="_blank" href="/purchase">{{ $t('payment_button_upgrade') }}</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageQuestion from '@/components/ImageQuestion.vue'
import HotspotAnswer from '@/components/HotspotAnswer.vue'

export default {
    name: 'correct-answers-popup',

    props: {
        question: Object,
        showTitle: {
            type: Boolean,
            default: true
        },
        rect: {
            type: DOMRect,
            default: null
        },
        isRectBottom: {
            type: Boolean,
            default: false
        },
        isAnimate: Boolean,

        leftGap: {
            type: Number,
            default: 0
        },
        master: {
            type: Boolean,
            default: false
        },
        isPaidUser: {
            type: Boolean,
            default: false
        }
    },

    components: {
        ImageQuestion,
        HotspotAnswer
    },

    computed: {
        isPuzzle() {
            return this.question.question_type === 'puzzle'
        },

        isSorting() {
            return this.question.question_type === 'sorting_list'
        },

        isHotspot() {
            return this.question.question_type === 'hotspot'
        },

        correctAnswer() {
            let transformCorrectAnswerData = []
            let question = {
                ...this.question
            }

            let isHasInitIndex = typeof question.answers[0].initIndex !== 'undefined'
            let answers = isHasInitIndex
                ? question.answers.sort((a, b) => {
                      return a.initIndex - b.initIndex
                  })
                : question.answers

            answers.map((answer, index) => {
                const condition = question.question_type != 'sorting_list' ? answer.is_correct : true
                if (condition) {
                    transformCorrectAnswerData.push({
                        title: answers[index].title,
                        image: answers[index].image ? answers[index].image : ''
                    })
                }
            })

            return transformCorrectAnswerData
        },

        answersRequired() {
            return this.question.answers_required
        },

        popupTop() {
            let pos = '15'
            if (this.rect) {
                if (this.isRectBottom) {
                    pos = this.rect.bottom
                } else {
                    pos = this.rect.top
                }
            }

            return pos
        },

        popupLeft() {
            if (this.rect) {
                return this.rect.left
            }

            return null
        },

        isCentered() {
            return this.leftGap == 0
        }
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        handlerShowChoices() {
            this.$emit('showChoices')
        }
    }
}
</script>

<style lang="scss">
.correct-answers-modal {
    background-color: var(--button-background-color);
    width: calc(100% - 10px);
    max-width: 430px;
    position: fixed;
    top: 0;
    transform: translateX(-50%);
    font-size: 0.5rem;
    z-index: 9999;
    overflow: auto;
    border-radius: 0.25rem;

    @media screen and (max-width: 1079px) {
        left: 50% !important;
    }

    > * {
        zoom: calc(var(--resize-scale) * 100%);
    }

    .hotspot-padding {
        @media screen and (max-width: 767px) {
            padding: 1rem 5rem !important;
        }
    }

    .title {
        padding: 0.6rem;
    }

    .close {
        top: 0.5rem;
        right: 0.75rem;

        i {
            color: var(--button-text-color);
        }
    }

    .sorting-list {
        counter-reset: sorting;

        .list-item-inner::before {
            counter-increment: sorting;
            content: '(' counter(sorting) ')';
            margin-left: 0.5rem;
            margin-right: 0.75rem;
        }
    }

    .list-item {
        word-break: break-word;
        padding: 0 0.75rem;
    }

    .answer-required-one,
    .answer-required-multiple {
        > .list-item::after {
            content: 'OR';
            display: block;
            text-align: center;
            margin: 0.5rem 0;
            font-size: 14px;
            font-weight: bold;
            color: var(--button-text-color);
            opacity: 0.5;
        }

        > .list-item:last-child::after {
            display: none;
        }
    }

    .answer-required-multiple {
        > .list-item::after {
            content: 'AND';
        }
    }

    .answer-container {
        max-height: 36vh;
        overflow-y: auto;
    }

    .upgrade-box {
        border: 1px solid var(--button-text-color) !important;
        border-radius: 6px;
        padding: 6px;
    }
}

@keyframes bounceIn {
    0%,
    20%,
    40%,
    60%,
    80%,
    to {
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        transform: translateX(-50%) scale3d(0.3, 0.3, 0.3);
    }
    20% {
        transform: translateX(-50%) scale3d(1.1, 1.1, 1.1);
    }
    40% {
        transform: translateX(-50%) scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        transform: translateX(-50%) scale3d(1.03, 1.03, 1.03);
    }
    80% {
        transform: translateX(-50%) scale3d(0.97, 0.97, 0.97);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) scaleX(1);
    }
}

.bounceIn {
    animation-duration: 0.75s;
    animation-name: bounceIn;
}

.centered-popup {
    left: 50% !important;
}

.master-centered-modal {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
}

.text-color {
    color: var(--button-text-color) !important;
}
</style>
